import React from 'react';
import { useNavigate } from 'react-router-dom';

const WA = 'https://wa.me/595976984144?text=';
const waLink = (msg) => WA + encodeURIComponent(msg);

const Check = () => (
  <svg className="w-4 h-4 text-green-400 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);

const PLANES_SAAS = [
  {
    id: 'basico', nombre: 'Básico', precio: 9.99, original: 19.99, badge: null,
    desc: 'Productores pequeños',
    features: ['Hasta 1.000 animales', '1 establecimiento', 'Usuarios ilimitados', 'Pesajes, GMD y genealogía', 'Modo offline + sincronización', 'Importación desde balanzas', 'Alertas productivas'],
  },
  {
    id: 'profesional', nombre: 'Profesional', precio: 24.99, original: 49.99, badge: 'Más elegido', destacado: true,
    desc: 'Productores medianos y consultores',
    features: ['Hasta 3.500 animales', '5 establecimientos', 'Todo lo del plan Básico', 'Protocolos IATF con calendario', 'Costos & Margen', 'Inventario sanitario', 'Reportes PDF con IA', 'Frame Score y eficiencia madre-cría'],
  },
  {
    id: 'plus', nombre: 'Plus', precio: 49.99, original: 99.99, badge: null,
    desc: 'Grandes empresas ganaderas',
    features: ['Hasta 12.000 animales', 'Establecimientos ilimitados', 'Todo lo del plan Profesional', 'Soporte prioritario', 'Asistente IA ilimitado', 'App de escritorio Windows/Linux'],
  },
];

const INTEGRAL_FEATURES = [
  'Software TKorveX Profesional incluido',
  'Digitalización inicial de todo tu rodeo (planillas, cuadernos, registros)',
  'Gestión remota mensual: cargamos y controlamos tus datos por vos',
  '4 visitas técnicas anuales a tu estancia',
  'Capacitación de tu personal en cada visita',
  'Informes productivos listos para decisiones',
  'Soporte directo por WhatsApp',
];

export default function PreciosPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-950 text-white overflow-x-hidden" data-testid="precios-page">
      {/* Navbar */}
      <nav className="fixed top-0 w-full z-50 bg-gray-950/80 backdrop-blur-md border-b border-gray-800/50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <button onClick={() => navigate('/landing')} className="flex items-center gap-3" data-testid="precios-logo">
            <img src="/logo192.png" alt="TKorveX" className="w-9 h-9 rounded-lg" />
            <span className="text-xl font-bold text-green-400">TKorveX</span>
          </button>
          <div className="flex items-center gap-3">
            <button onClick={() => navigate('/login')} className="px-4 py-2 text-sm text-gray-300 hover:text-white transition" data-testid="precios-login-btn">Iniciar Sesión</button>
            <button onClick={() => navigate('/register')} className="px-4 py-2 bg-green-600 hover:bg-green-500 text-sm font-semibold rounded-lg transition" data-testid="precios-register-btn">Registrarse</button>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="pt-32 pb-12 px-6 text-center">
        <h1 className="text-4xl sm:text-5xl font-bold">Precios simples, <span className="text-green-400">sin sorpresas</span></h1>
        <p className="text-gray-400 mt-4 max-w-2xl mx-auto">Probá el sistema completo <strong className="text-white">gratis durante 30 días con hasta 500 animales</strong>. Cuando tu rodeo crezca, elegí el plan que se adapte a tu operación — o dejanos todo a nosotros con el Servicio Integral.</p>
        <div className="mt-6 inline-flex items-center gap-2 px-4 py-2 bg-green-500/10 border border-green-500/30 rounded-full text-sm text-green-300" data-testid="precios-trial-banner">
          <Check /> 30 días de prueba gratis · hasta 500 animales · sin tarjeta de crédito
        </div>
      </section>

      {/* Planes SaaS */}
      <section className="px-6 pb-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
          {PLANES_SAAS.map(p => (
            <div key={p.id}
              className={`relative rounded-2xl p-7 border ${p.destacado ? 'border-green-500 bg-gradient-to-b from-green-950/60 to-gray-900 shadow-lg shadow-green-900/30 md:-mt-3 md:mb-3' : 'border-gray-800 bg-gray-900/60'}`}
              data-testid={`plan-${p.id}`}>
              {p.badge && (
                <span className={`absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 text-xs font-bold rounded-full ${p.destacado ? 'bg-green-500 text-gray-950' : 'bg-gray-700 text-gray-200'}`}>{p.badge}</span>
              )}
              <h3 className="text-lg font-bold">{p.nombre}</h3>
              <p className="text-xs text-gray-400 mt-1">{p.desc}</p>
              <div className="mt-4 flex items-end gap-2">
                <span className="text-4xl font-bold">${p.precio}</span>
                <span className="text-gray-400 text-sm mb-1">USD/mes</span>
                <span className="text-gray-500 text-sm line-through mb-1">${p.original}</span>
              </div>
              <p className="text-xs text-green-400 mt-1">Precio de lanzamiento · 50% de descuento</p>
              <ul className="mt-5 space-y-2.5">
                {p.features.map(f => (
                  <li key={f} className="flex items-start gap-2 text-sm text-gray-300"><Check /> {f}</li>
                ))}
              </ul>
              <button onClick={() => navigate('/register')}
                className={`mt-6 w-full py-2.5 rounded-lg font-semibold text-sm transition ${p.destacado ? 'bg-green-500 hover:bg-green-400 text-gray-950' : 'bg-gray-800 hover:bg-gray-700 text-white border border-gray-700'}`}
                data-testid={`plan-cta-${p.id}`}>
                Empezar ahora
              </button>
            </div>
          ))}
        </div>
        <div className="max-w-7xl mx-auto mt-6 rounded-2xl border border-gray-800 bg-gray-900/60 p-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4" data-testid="plan-enterprise">
          <div>
            <h3 className="text-lg font-bold">Enterprise <span className="ml-2 text-xs font-semibold text-amber-400 bg-amber-950/60 border border-amber-500/40 rounded-full px-2 py-0.5">Consultar cotización</span></h3>
            <p className="text-sm text-gray-400 mt-1">Grupos ganaderos, pools de inversión y cooperativas con más de 12.000 animales. Animales y establecimientos ilimitados, personalización, integraciones a medida, SLA y capacitación de equipos.</p>
          </div>
          <a href={`${WA}${encodeURIComponent('Hola, quiero una cotización del plan Enterprise de TKorveX.')}`} target="_blank" rel="noopener noreferrer"
            className="shrink-0 px-5 py-2.5 rounded-lg font-semibold text-sm bg-gray-800 hover:bg-gray-700 text-white border border-gray-700 transition"
            data-testid="plan-cta-enterprise">
            Pedir cotización
          </a>
        </div>
      </section>
      <section className="px-6 pb-16">
        <div className="max-w-7xl mx-auto rounded-2xl border border-amber-500/40 bg-gradient-to-br from-amber-950/40 via-gray-900 to-gray-900 p-8 md:p-10" data-testid="plan-integral">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <span className="inline-block px-3 py-1 text-xs font-bold rounded-full bg-amber-500 text-gray-950">SERVICIO INTEGRAL — Llave en mano</span>
              <h2 className="text-2xl md:text-3xl font-bold mt-4">¿No tenés tiempo ni personal para cargar datos?<br /><span className="text-amber-400">Nosotros lo hacemos por vos.</span></h2>
              <p className="text-gray-400 mt-3 text-sm leading-relaxed">
                Pensado para estancias que quieren los resultados sin ocuparse del sistema: digitalizamos tu rodeo completo, gestionamos tus datos todos los meses y visitamos tu campo 4 veces al año.
              </p>
              <div className="mt-6 flex flex-wrap items-end gap-x-8 gap-y-3">
                <div>
                  <p className="text-xs text-gray-400 uppercase">Implementación única</p>
                  <p className="text-3xl font-bold text-white">USD 800</p>
                </div>
                <div>
                  <p className="text-xs text-gray-400 uppercase">Servicio anual todo incluido</p>
                  <p className="text-3xl font-bold text-amber-400">USD 900<span className="text-base text-gray-400 font-normal">/año</span></p>
                </div>
                <div>
                  <p className="text-xs text-gray-400 uppercase">Visita adicional</p>
                  <p className="text-xl font-bold text-gray-300">USD 250</p>
                </div>
              </div>
              <a href={waLink('Hola, quiero información sobre el Servicio Integral de TKorveX para mi estancia')}
                target="_blank" rel="noopener noreferrer"
                className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-amber-500 hover:bg-amber-400 text-gray-950 font-bold rounded-lg transition"
                data-testid="integral-cta">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                Solicitar por WhatsApp
              </a>
              <p className="text-xs text-gray-500 mt-3">Año 1: USD 1.700 (setup + servicio) · Año 2 en adelante: USD 900/año</p>
            </div>
            <ul className="space-y-3">
              {INTEGRAL_FEATURES.map(f => (
                <li key={f} className="flex items-start gap-3 text-sm text-gray-200 bg-gray-900/70 border border-gray-800 rounded-lg px-4 py-3"><Check /> {f}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Comparación rápida */}
      <section className="px-6 pb-16">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl font-bold text-center mb-8">¿Cuál me conviene?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="rounded-xl border border-gray-800 bg-gray-900/60 p-6">
              <h3 className="font-bold text-green-400">Plan SaaS (autogestión)</h3>
              <p className="text-sm text-gray-400 mt-2 leading-relaxed">Vos o tu personal cargan los datos desde el celular o la balanza. Ideal si ya tenés alguien que maneja planillas y querés pagar poco por mes.</p>
            </div>
            <div className="rounded-xl border border-gray-800 bg-gray-900/60 p-6">
              <h3 className="font-bold text-amber-400">Servicio Integral</h3>
              <p className="text-sm text-gray-400 mt-2 leading-relaxed">Nosotros digitalizamos, cargamos y controlamos todo, con visitas a tu campo. Ideal para estancias grandes sin personal administrativo dedicado.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="px-6 pb-16">
        <div className="max-w-3xl mx-auto space-y-4">
          <h2 className="text-2xl font-bold text-center mb-8">Preguntas frecuentes</h2>
          {[
            ['¿Puedo probar antes de pagar?', 'Sí. Registrate gratis y usá el sistema completo durante 30 días con hasta 500 animales, sin tarjeta ni compromiso.'],
            ['¿Cómo se paga?', 'Los planes SaaS se pagan por mes con tarjeta vía PayPal y podés cancelar cuando quieras. El Servicio Integral se abona una vez al año.'],
            ['¿Funciona sin internet en el campo?', 'Sí. TKorveX funciona offline y sincroniza automáticamente cuando volvés a tener señal.'],
            ['¿Sirve para cría y ciclo completo?', 'Sí. Maneja las 6 categorías oficiales SIAP/SITRAP, eficiencia madre-cría, destete, engorde, pesajes con GMD y protocolos IATF.'],
          ].map(([q, a]) => (
            <div key={q} className="rounded-xl border border-gray-800 bg-gray-900/60 p-5">
              <h3 className="font-semibold text-white text-sm">{q}</h3>
              <p className="text-sm text-gray-400 mt-1.5">{a}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA final */}
      <section className="px-6 pb-20 text-center">
        <h2 className="text-3xl font-bold">Empezá hoy, <span className="text-green-400">gratis</span></h2>
        <p className="text-gray-400 mt-3 mb-6">30 días de prueba con hasta 500 animales. Sin tarjeta de crédito.</p>
        <button onClick={() => navigate('/register')} className="px-8 py-3 bg-green-600 hover:bg-green-500 font-bold rounded-lg transition" data-testid="precios-cta-final">Crear mi cuenta gratis</button>
      </section>

      <footer className="border-t border-gray-800 py-8 text-center text-xs text-gray-500">
        TKorveX · Gestión ganadera inteligente · Paraguay
      </footer>
    </div>
  );
}
